export enum InvitationStatus {
  Sent,
  Accepted,
  Rejected,
  Pending,
  Delivered,
  Failed,
}
